import NotFoundProvider from './hooks/useNotFound';

import { NotFoundProps } from './@types/NotFoundProps';

const NotFound = (props: NotFoundProps) => <NotFoundProvider {...props}></NotFoundProvider>;

export default NotFound;
